import { Brick, registerBrick } from 'olympe';

export default class BuildGraphAPIUsersStringFromSuggestions extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} suggestions
     * @param {function()} forwardEvent
     * @param {function(string)} setFirstUser
     * @param {function(string)} setOROtherUsers
     * @param {function(boolean)} setNoUser
     */
    update($, [suggestions], [forwardEvent, setFirstUser, setOROtherUsers, setNoUser]) {
        const suggestionsObj = JSON.parse(suggestions);
        /**@type {Array<Object>}*/
        const results = suggestionsObj['results'];
        const noUser = results?.length === 0 || false;
        let firstUserString = '';
        let otherUserString = '';
        if (results.length > 1) {
            // OR mail:email2 OR mail:email3
            // last " is added by DRAW
            otherUserString = '" OR "mail:' + results.slice(1).map(res => res.pmEmail).join('" OR "mail:');
        }
        if (results?.length) {
            firstUserString = results[0].pmEmail;
        }
        setFirstUser(firstUserString);
        setOROtherUsers(otherUserString);
        setNoUser(noUser);
        forwardEvent();
    }
}

registerBrick('018a21b4fe4360b9a599', BuildGraphAPIUsersStringFromSuggestions);
